<script>
	import Sidebar from '../Sidebar.svelte'
	import Contact from '../../States/Contact'
	import Router from '../../States/Router'

	let list = [];

	function goToContact(id, edit, call) {
		if(call)
			Router.component('conference', {call: true, contact: true, contactId: id})
		else
			Router.component('contact', {id, edit})
	}

	async function init() {
		const response = await Contact.list();
		if(response.success)
			list = response.contacts

		setTimeout(() => initTable(), 300);
	}

	function initTable() {
		window.$('#contact-table').DataTable({
			keys: true,
			"language": {
				"paginate": {
					"previous": "<i class='mdi mdi-chevron-left'>",
					"next": "<i class='mdi mdi-chevron-right'>"
				}
			},
			"drawCallback": function () {
				window.$('.dataTables_paginate > .pagination').addClass('pagination-rounded');
			}
		});
	}

	init()
</script>

<style>

	.table-action {
		text-align: right;
	}
</style>

<div class="container-fluid">
	<div class="wrapper">
		<Sidebar/>
		<div class="content-page">
			<div class="content">
				<div class="row">
					<div class="col-12">
						<div class="page-title-box">
							<h4 class="page-title">Contacts</h4>
						</div>
					</div>
				</div>

				<div class="row">
					<div class="card">
						<div class="card-body">
							<table id="contact-table" class="table table-centered table-striped mb-0">
								<thead>
									<tr>
										<th>Name</th>
										<th>Phone Number</th>
										<th>Email</th>
										<th>&nbsp;</th>
									</tr>
								</thead>
								<tbody>
									{#if list.length}
										{#each list as item}
											<tr>
												<td>{item.name}</td>
												<td>{item.phone}</td>
												<td>{item?.mail ? item.mail : ''}</td>
												<td class="table-action">
													<a href="#" class="action-icon" on:click|preventDefault={() => goToContact(item.id, true, false)}> <i class="uil uil-edit-alt"></i></a>
													<a href="#" class="action-icon" on:click|preventDefault={() => goToContact(item.id, false, true)}> <i class="uil uil-outgoing-call"></i></a>
												</td>
											</tr>
										{/each}
									{/if}
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
